// Import Packages
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useSetRecoilState} from 'recoil';

// Import Helpers
import {getExtension} from '../../../../../helpers/helper';
import {alertState} from '../../../../../recoil-store/recoil-state';

const StepUploadJson = ({appConfigFile, setAppConfigFile, setIsRequired, has_application_json,}) => {
    const setAlert = useSetRecoilState(alertState);
    const {t} = useTranslation();

    useEffect(() => {
        if (has_application_json || appConfigFile) {
            setIsRequired(false);
        } else {
            setIsRequired(true);
        }
    }, [])

    const handleInputChange = (event) => {
        if (event.target.files[0]?.name) {
            let extension = getExtension(event.target.files[0]?.name);
            if (extension === 'json') {
                setAppConfigFile(event.target.files[0]);
                setIsRequired(false);
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.PUBLISH.JSON-FORMAT-ERROR'),
                    severity: 'error'
                }))
            }
        }
    };

    return (
        <div className="upload-json-container">

            <div
                className="upload-json-title">{t('CONTENT.PUBLISH.' + (has_application_json || appConfigFile ? 'REPLACE-UPLOAD-JSON-TITLE' : 'UPLOAD-JSON-TITLE'))}</div>
            <div className="upload-json-input">
                {appConfigFile ? <>
                        <div className="custom-file">
                            <input style={{position: 'relative'}} type="file" className="custom-file-input" accept=".json"
                                   id="license-customFile"
                                   onChange={handleInputChange}/>
                            <label className="upload-json-label"
                                   htmlFor="license-customFile"><span>{appConfigFile?.name ? appConfigFile.name : t('CONTENT.SETTINGS.GENERAL.CHOOSE')}</span></label>
                        </div>
                    </> :
                    <label className="activate-license sgeneral-save"
                           style={{width: 'auto'}}>{t('CONTENT.PUBLISH.UPLOAD-JSON')}
                        <input type="file" accept=".json" onChange={handleInputChange}/>
                    </label>
                }
            </div>

        </div>
    )
}

export default StepUploadJson;
